import React from "react";
import { Colors } from '_styles';

const CircleText = (props) => {

    return (
        <div style={{ display: 'flex', marginLeft: props.margin ? 6 : 0, opacity: props.forecast ? 0.8 : 1.0, marginTop: props.marginTop ? props.marginTop : 0 }}>
            <div style={{
                backgroundColor: props.color,
                borderRadius: 5,
                width: 140,
                height: 30,
                borderStyle: 'solid',
                borderColor: props.textColor,
                borderWidth: 0.5,
                display: 'flex',             
                alignItems: 'center',         
                justifyContent: 'center',     
            }}>
                <p style={{
                    fontSize: 14,
                    fontWeight: 'bold',
                    margin: 0,                   
                    color: props.type == 'total' ? Colors.PRM_LIGHT_BLUE : props.textColor || 'white'
                }}>
                    {props.isLoading ? '' : props.value}
                </p>
            </div>
        </div>
    );
}

export default CircleText;